import * as core from '../../../../../../../core'

import { query } from './delete-proposal-personnel-row.query'

export const RESOURCE = {
  payload: {
    alias: 'delete.proposal.personnel.row',
    description:
      'Deletes a proposal-personnel row from the proposal-personnel row edit modal',
    name: 'Delete Proposal Personnel Row',
    query,
  },
  type: core.quiver.Resource.Type.MosaicAction,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicAction>
